import React from 'react';
import {
  UseHitsPerPageProps,
  useHitsPerPage,
  useInstantSearch,
  usePagination,
  useSearchBox,
} from 'react-instantsearch';
import { Hit } from '@algolia/client-search';
import {
  PageInfo,
  Plan,
  ShopItem,
  Subscription,
  User,
} from '../../../../models';
import SearchInput from '../../SearchInput';
import EmployeeCheck from './EmployeeCheck';
import Pagination from '../../Pagination';
import { AlgoliaHitToObject } from '../../../../lib';

interface SelectEmployeeProps {
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  searchText: string;
  shopList: ShopItem[];
  setShopList: React.Dispatch<React.SetStateAction<ShopItem[]>>;
  productType: 'product' | 'plan' | 'benefit';
  plans?: Plan[];
  benefitValue: number;
}

function SelectEmployee({
  setSearchText,
  searchText,
  shopList,
  setShopList,
  productType,
  plans,
  benefitValue,
}: SelectEmployeeProps) {
  useHitsPerPage({
    items: [{ value: 200, label: '200', default: true }],
  } as UseHitsPerPageProps);

  const { refine: redefineSearch } = useSearchBox();

  const { results, status, refresh } = useInstantSearch();
  const [pageInfoAlgolia, setPageInfoAlgolia] = React.useState<PageInfo>({
    currentPage: 0,
    perPage: 6,
    itemCount: 0,
    pageCount: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  const { refine } = usePagination();
  // FIXME: AYUDA SANTI
  React.useEffect(() => {
    refine(pageInfoAlgolia.currentPage);
  }, [pageInfoAlgolia.currentPage]);

  React.useEffect(() => {
    console.log('refreshing...');
    refresh();
  }, []);

  const handleCheck = (employee: Hit<User>) => {
    const employeeInShopList = shopList?.find(
      (s) => (s.client as User)._id === employee._id
    );

    if (employeeInShopList) {
      const newShopList = shopList?.filter(
        (e) => (e.client as User)._id !== employee._id
      );
      setShopList(newShopList);
    } else if (productType === 'benefit' && employee.discountCoupons > 0) {
      const plan = plans?.find(
        (p) => p?._id === (employee?.currentSubscription as Subscription)?.plan
      );

      setShopList([
        ...shopList,
        {
          client: { ...employee, _id: employee._id },
          quantity: 1,
          ...(productType === 'benefit' && {
            benefitValue: plan?.couponPrice ?? benefitValue,
          }),
        },
      ]);
    } else {
      setShopList([
        ...shopList,
        {
          client: { ...employee, _id: employee._id },
          quantity: 1,
          ...(productType === 'benefit' && { benefitValue }),
        },
      ]);
    }
  };

  return (
    <>
      <SearchInput
        className="w-full"
        label="Buscar beneficiarios"
        placeholder="Busque el nombre del beneficiario"
        searchText={searchText}
        setSearchText={setSearchText}
        action={() => {
          redefineSearch(searchText);
        }}
      />
      {status === 'idle' ? (
        <>
          <div className="h-44 overflow-auto mt-5">
            {[...AlgoliaHitToObject<User>(results.hits as Hit<User>[])]?.map(
              (employee) => (
                <EmployeeCheck
                  key={employee?.objectID}
                  employee={employee}
                  handleCheck={handleCheck}
                  checked={
                    !!shopList?.find(
                      (s) => (s?.client as User)?._id === employee?._id
                    )
                  }
                />
              )
            )}
          </div>
          <Pagination
            pageInfo={{
              currentPage: results.page,
              perPage: 10,
              itemCount: results.nbHits,
              pageCount: results.nbPages,
              hasPreviousPage: results.page > 0,
              hasNextPage: results.page < results.nbPages - 1,
            }}
            scrollToTop={false}
            setPageInfo={setPageInfoAlgolia}
            type="algolia"
          />
        </>
      ) : null}
    </>
  );
}

export default SelectEmployee;
